var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8462 2.42308C24.8769 2.90769 23.9077 3.06923 22.7769 3.23077C23.9077 2.58462 24.7154 1.61538 25.0385 0.323077C24.0692 0.96923 22.9385 1.29231 21.6462 1.61538C20.6769 0.646154 19.2231 0 17.7692 0C14.3769 0 11.7923 3.23077 12.6 6.46154C8.23846 6.3 4.36154 4.2 1.61538 0.969231C0.161538 3.39231 0.969231 6.46154 3.23077 8.07692C2.42308 8.07692 1.61538 7.75385 0.807692 7.43077C0.807692 9.85385 2.58462 12.1154 5.00769 12.7615C4.2 12.9231 3.39231 13.0846 2.58462 12.9231C3.23077 15.0231 5.16923 16.6385 7.59231 16.6385C5.65385 18.0923 2.74615 18.9 0 18.5769C2.42308 20.0308 5.16923 21 8.07692 21C17.9308 21 23.4231 12.7615 23.1 5.16923C24.2308 4.52308 25.2 3.55385 25.8462 2.42308Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.798ed8d0.svg";
export { ForwardRef as ReactComponent };